<template>
    <div>
        <div class="symbols pb-2">
            <dice v-if="game.name == 'Dice'" :game-id="gameId" @select="selectItem" :selected-items="selectedItems"></dice>
            <basic v-else :game-name="game.name" :game-id="gameId" @select="selectItem" :selected-items="selectedItems"></basic>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Basic from "./Basic";
import Dice from "./Dice";

export default {
    props: ['gameId', 'selectedItems'],

    components: { Basic, Dice },

    computed: {
        game() {
            return Config.games[this.gameId];
        },
    },

    methods: {
        selectItem({ id }) {
            if (!this.isSelected(id)) {
                this.$emit('add', id);
            } else {
                this.$emit('remove', id);
            }
        },

        isSelected(id) {
            return this.selectedItems.includes(id);
        },
    },
}
</script>

